

import { triggerEvent, useEventListener } from "@/common/event";

export function showLoad(msg = '') {
    triggerEvent('show-load', msg)
}

export function hideLoad() {
    triggerEvent('hide-load')
}
